import { API_PDC_URL_V2, API_PDC_URL_V3, PDC_URL_V2 } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { getQueryString } from "../../services/rest-api-call";
import { overflowNotificationConstants } from "../overflowNotification";

export const detailConstants = {
  GET_RECURENCY_START: "GET_RECURENCY_START",
  GET_RECURRENCY_SUCCESS: "GET_RECURRENCY_SUCCESS",
  GET_RECURRENCY_ERROR: "GET_RECURRENCY_ERROR",

  GET_DEADLINES_DETAIL_START: "GET_DEADLINES_DETAIL_START",
  GET_DEADLINES_DETAIL_SUCCESS: "GET_DEADLINES_DETAIL_SUCCESS",
  GET_DEADLINES_DETAIL_ERROR: "GET_DEADLINES_DETAIL_ERROR",

  SET_DEADLINES_VIEWED_START: "SET_DEADLINES_VIEWED_START",
  SET_DEADLINES_VIEWED_SUCCESS: "SET_DEADLINES_VIEWED_SUCCESS",
  SET_DEADLINES_VIEWED_ERROR: "SET_DEADLINES_VIEWED_ERROR",

  SET_DEADLINES_AUTHORIZE_START: "SET_DEADLINES_AUTHORIZE_START",
  SET_DEADLINES_AUTHORIZE_SUCCESS: "SET_DEADLINES_AUTHORIZE_SUCCESS",
  SET_DEADLINES_AUTHORIZE_ERROR: "SET_DEADLINES_AUTHORIZE_ERROR",

  SET_DEADLINES_REJECT_START: "SET_DEADLINES_REJECT_START",
  SET_DEADLINES_REJECT_SUCCESS: "SET_DEADLINES_REJECT_SUCCESS",
  SET_DEADLINES_REJECT_ERROR: "SET_DEADLINES_REJECT_ERROR",

  SET_DEADLINES_PAYMENT_START: "SET_DEADLINES_PAYMENT_START",
  SET_DEADLINES_PAYMENT_SUCCESS: "SET_DEADLINES_PAYMENT_SUCCESS",
  SET_DEADLINES_PAYMENT_ERROR: "SET_DEADLINES_PAYMENT_ERROR",

  UPDATE_ATTACHMENTS_DETAIL_START: "UPDATE_ATTACHMENTS_DETAIL_START",
  UPDATE_ATTACHMENTS_DETAIL_SUCCESS: "UPDATE_ATTACHMENTS_DETAIL_SUCCESS",
  UPDATE_ATTACHMENTS_DETAIL_ERROR: "UPDATE_ATTACHMENTS_DETAIL_ERROR",

  GET_DEADLINES_DAILYTOTALS_START: "GET_DEADLINES_DAILYTOTALS_START",
  GET_DEADLINES_DAILYTOTALS_SUCCESS: "GET_DEADLINES_DAILYTOTALS_SUCCESS",
  GET_DEADLINES_DAILYTOTALS_ERROR: "GET_DEADLINES_DAILYTOTALS_ERROR",

  MODIFIED_DEADLINES_START: "MODIFIED_DEADLINES_START",
  MODIFIED_DEADLINES_SUCCESS: "MODIFIED_DEADLINES_SUCCESS",
  MODIFIED_DEADLINES_ERROR: "MODIFIED_DEADLINES_ERROR",

  SPLIT_DEADLINES_START: "SPLIT_DEADLINES_START",
  SPLIT_DEADLINES_SUCCESS: "SPLIT_DEADLINES_SUCCESS",
  SPLIT_DEADLINES_ERROR: "SPLIT_DEADLINES_ERROR"
};

export function getDeadlineDetail(deadlineId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: API_PDC_URL_V3 + "/deadlines/" + deadlineId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: detailConstants.GET_DEADLINES_DETAIL_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          dispatch({
            type: detailConstants.GET_DEADLINES_DETAIL_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: detailConstants.GET_DEADLINES_DETAIL_ERROR,
            payload: { error: response }
          });
          reject();
        });
    });
  };
}

export function getRecurrency(queryParameters = {}) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;

    const accountantSelected = main.accountantSelected;
    const accountantUuidSelected = main.accountantUuidSelected;
    const clientIdSelected = main.clientIdSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const params = {
      itemId: companyUuidSelected,
      managerId: accountantUuidSelected,
      first: queryParameters.first,
      after: "0",
      recurrenceId: queryParameters.recurrenceId ? queryParameters.recurrenceId : null
    };

    let newParams = getQueryString(params);
    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.GET_RECURENCY_START,
        payload: { recurrency: null }
      });
      let request = {
        method: "GET",
        url: API_PDC_URL_V3 + "/deadlines" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          "X-Manager-ID": accountantSelected,
          "X-Item-ID": clientIdSelected
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.GET_RECURRENCY_SUCCESS,
            payload: {
              recurrency: response.data
            }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: detailConstants.GET_RECURRENCY_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

export function getDailyTotals(day) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const companyUuidSelected = main.companyUuidSelected;
    const accountantUuidSelected = main.accountantUuidSelected;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.GET_DEADLINES_DAILYTOTALS_START
      });

      let request = {
        method: "GET",
        url: `${API_PDC_URL_V3}/deadlines/dailyTotalAmount?itemId=${companyUuidSelected}&managerId=${accountantUuidSelected}&day=${day}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.GET_DEADLINES_DAILYTOTALS_SUCCESS,
            payload: response.data._embedded
          });
          resolve(response.data);
        })
        .catch((error) => {
          dispatch({
            type: detailConstants.GET_DEADLINES_DAILYTOTALS_ERROR,
            payload: { error: error }
          });
          reject(error);
        });
    });
  };
}

export function modifyDeadline(removedObj) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const idDeadline = getState().deadlinesDetail.subjective.id;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.MODIFIED_DEADLINES_START
      });

      let request = {
        method: "PATCH",
        url: `${API_PDC_URL_V2}/deadlines/${idDeadline}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: removedObj
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.MODIFIED_DEADLINES_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: detailConstants.MODIFIED_DEADLINES_ERROR,
            payload: { error: err }
          });
          reject(err);
        });
    });
  };
}

export function setDeadlineDetailViewed(deadlineId, viewed) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.SET_DEADLINES_VIEWED_START
      });

      let request = {
        method: "PATCH",
        url: API_PDC_URL_V2 + "/deadlines/" + deadlineId + "/view/" + viewed,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_VIEWED_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_VIEWED_ERROR,
            payload: { error: err }
          });
          reject(err);
        });
    });
  };
}

export function setDeadlineDetailAuthorize() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const deadlinesDetail = getState().deadlinesDetail?.subjective;

    const authorizeUrl = deadlinesDetail ? deadlinesDetail._links.authorize.href : null;

    return new Promise(function(resolve, reject) {
      let request = {
        method: "PATCH",
        url: authorizeUrl,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: detailConstants.SET_DEADLINES_AUTHORIZE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_AUTHORIZE_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_AUTHORIZE_ERROR,
            payload: { error: err }
          });

          dispatch({
            type: overflowNotificationConstants.SHOW_OVERFLOW,
            payload: {
              type: "error",
              title: "Errore",
              message: "Si è verificato un errore durante l'Autorizzazione della scadenza"
            }
          });

          reject(err);
        });
    });
  };
}

export function setDeadlineDetailReject() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const deadlinesDetail = getState().deadlinesDetail?.subjective;

    const rejectUrl = deadlinesDetail ? deadlinesDetail._links.reject.href : null;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.SET_DEADLINES_REJECT_START
      });
      let request = {
        method: "PATCH",
        url: rejectUrl,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_REJECT_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_REJECT_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

export function setDeadlineDetailPayment(
  deadlineId, paymentStatus, paymentMode, paymentDate
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    let paymentDateFormat = new Date(paymentDate);
    let bodyRequest = {
      status: paymentStatus,
      execution: { date: paymentDateFormat, mode: paymentMode }
    };
    if (paymentStatus === "suspended" || paymentStatus === "due" || paymentStatus === "unpaid") {
      bodyRequest = {
        status: paymentStatus
      };
    }

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.SET_DEADLINES_PAYMENT_START
      });
      let request = {
        method: "PATCH",
        url: API_PDC_URL_V2 + "/deadlines/" + deadlineId + "/payment/status",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: bodyRequest
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_PAYMENT_SUCCESS,
            payload: {
              paymentStatus,
              paymentDate,
              paymentMode
            }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: detailConstants.SET_DEADLINES_PAYMENT_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

export function splitDeadlines(
  idDeadline, splitList, partialPayment = false
) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    let successText = null;
    if (partialPayment) {
      successText = "Pagamento registrato: la nuova scadenza è stata creata con importo residuo";
    }

    return new Promise(function(resolve, reject) {
      dispatch({
        type: detailConstants.SPLIT_DEADLINES_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/deadlines/${idDeadline}/split`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: { parts: splitList }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: detailConstants.SPLIT_DEADLINES_SUCCESS,
            payload: response.data
          });
          if (successText) {
            dispatch({
              type: overflowNotificationConstants.SHOW_OVERFLOW,
              payload: {
                type: "success",
                title: "OK",
                message: successText
              }
            });
          }
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: detailConstants.SPLIT_DEADLINES_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

export function getNumberPages(
  auth, dispatch, accountantSelected, accountantIdSelected, companySelected, clientIdSelected, id
) {
  let request = {
    method: "get",
    url: `${PDC_URL_V2}/documents/${id}?itemId=${clientIdSelected}&accountantId=${accountantIdSelected}`,
    headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
  };

  return new Promise((resolve, reject) => {
    return callWithRetry(
      auth, request, dispatch
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getNumberPagesAttachments(
  companySelected, clientIdSelected, attachments
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantSelected = main.accountantSelected;
    const accountantIdSelected = main.accountantIdSelected;

    dispatch({
      type: detailConstants.UPDATE_ATTACHMENTS_DETAIL_START
    });

    let promises = [];
    for (let t = 0; t < attachments.length; t++) {
      let promise;

      promise = getNumberPages(
        auth, dispatch, accountantSelected, accountantIdSelected, companySelected, clientIdSelected, attachments[t].id
      );

      promises.push(promise);
    }

    return Promise.all(promises).then((values) => {
      dispatch({
        type: detailConstants.UPDATE_ATTACHMENTS_DETAIL_SUCCESS,
        payload: values
      });
    });
  };
}
